import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import { ordersCompleteSetFilterTime, ordersCompleteSetFilterSearch } from './../store/ordersComplete/actions';

import Icon from './Icon';
import Dropdown from './Dropdown';
import Select from './Select';
import OrdersTableSearch from './OrdersTableSearch';

class OrdersCompleteTableFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searchValue: ''
        };

        this.onToggleSearchClick = this.onToggleSearchClick.bind(this);
        this.onSearchSubmit = this.onSearchSubmit.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
    }

    componentDidMount() {
        const { setFilterSearch } = this.props;
        setFilterSearch('');
    }

    onSearchSubmit(event) {
        event.preventDefault();
        const { searchValue } = this.state;
        const { setFilterSearch } = this.props;
        setFilterSearch(searchValue.trim());
    }

    onToggleSearchClick() {
        const { setFilterSearch, isSearch, onSearchChange } = this.props;
        this.setState(state => {
            const newIsSearch = !isSearch;
            if (!newIsSearch) {
                setFilterSearch('');
            }
            onSearchChange(newIsSearch);
        });
    }

    onInputChange(event) {
        const target = event.target;
        this.setState(state => Object.assign({}, state, {
            [target.name]: target.value
        }));
    }

    render() {
        const {
            translate,
            className,
            filter,
            filterTimesLong,
            setFilterTime,
            isSearch
        } = this.props;
        const { searchValue } = this.state;

        if (isSearch) {
            return (
                <div className={className}>
                    <OrdersTableSearch
                        onSubmit={this.onSearchSubmit}
                        value={searchValue}
                        onChange={this.onInputChange}
                        onToggleClick={this.onToggleSearchClick}
                    />
                </div>
            );
        }

        return (
            <div className={className}>
                <div className="row">
                    <div className="col-1">
                        <button type="button" className="btn btn-filter-search" onClick={this.onToggleSearchClick}><Icon className="svg-icon" iconName="search" /></button>
                    </div>
                    <div className="col-2">
                        <Dropdown text={translate(`timeFilter.${filter.time}`)} closeAlways>
                            <Select className="menu menu-selectable" onChange={setFilterTime} value={filter.time}>
                                {filterTimesLong.map(item =>
                                    <li key={item} value={item} className="menu-item">{translate(`timeFilter.${item}`)}</li>
                                )}
                            </Select>
                        </Dropdown>
                    </div>
                    <div className="col-12"></div>
                    <div className="col-12"></div>
                </div>
            </div>
        );
    };
}

const mapStateToProps = (state, ownProps) => {
    const translate = getTranslate(state.locale);
    const filter = state.ordersComplete.filter
    const filterTimesLong = state.settings.filterTimesLong;
    return { filter, filterTimesLong, translate };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setFilterTime: value => dispatch(ordersCompleteSetFilterTime(value)),
        setFilterSearch: value => dispatch(ordersCompleteSetFilterSearch(value)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrdersCompleteTableFilter);


// WEBPACK FOOTER //
// ./src/components/OrdersCompleteTableFilter.js